<template>
  <avs-card noTitle>
    <template v-slot:content>
      <v-card-text
        ><v-alert
          v-if="!isPublished"
          class="mt-8"
          color="secondary"
          type="info"
          outlined
        >
          <div>{{ $t("views.template.document.in_order_to_export") }}</div>
          <div>{{ $t("views.template.document.note") }}</div>
        </v-alert>

        {{ $t("views.template.document.missing_signatures", { missing: missing }) }}

        <avs-button
          v-if="!isCompleted"
          block
          color="blue white--text"
          class="mt-4"
          :disabled="isSignedByUser"
          noSpantext
          @click="sign"
        >
          <template v-slot:name>
            {{ $t("commons.sign") }}
          </template>
        </avs-button>

        <AvsList dense>
          <v-list-item
            v-for="(item, index) in signatures"
            :key="index"
          >
            <v-list-item-content>
              <v-list-item-title>
                <v-icon>mdi-account</v-icon>
                {{ item.user.email }}
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-icon>mdi-calendar-blank</v-icon>
                {{ item.date }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </AvsList>

        <avs-button
          v-if="canBePublished"
          @click="publish"
          class="mt-4"
          color="success"
          :disabled="isPublished"
          block
          noSpantext
          iconI="mdi-checkbox-marked-circle"
        >
          <template v-slot:name>
            {{ isPublished ? $t("actions.published") : $t("actions.publish", { entity: "" }) }}
          </template>
        </avs-button>
        <input
          v-show="false"
          type="file"
          accept="image/*"
          ref="uploadInput"
          @change="handleChange"
        />
        <avs-deleteDialog
          v-model="deleteDialogIsOpen"
          @cancel="handleCancel"
          @delete="handleDelete"
          resource="signature picture"
        />
      </v-card-text>
    </template>
  </avs-card>
</template>

<script>
import { DocumentService } from "@/services/documents"
import { STATE_ENUM } from "@/utils/consts"
import { imageValidator } from "@/utils/validator"

export default {
  name: "DocumentSign",
  components: {
    AvsList: () => import("@/components/generics/general/AvsList.vue")
    // PicturePreview: () => import("../non-conformity/NonConformityPicturePreview.vue")
  },
  props: {
    document: {
      type: Object,
      required: true
    },
    signatures: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    canBePublished() {
      // Document can be published if at leat 1 signature
      return this.isCompleted || this.signatures.length > 0
    },
    isCompleted() {
      // Document is completed if no more missing signatures
      return this.missing === 0
    },
    isPublished() {
      return this.document.state.id === STATE_ENUM.PUBLISHED.id
    },
    isSignedByUser() {
      const currentUser = this.$store.state.app.user
      return this.signatures.findIndex(e => e.user.id === currentUser.id) > -1
    },
    missing() {
      return Math.max(this.document.template.nb_signatures - this.signatures.length, 0) || 0
    }
  },
  data() {
    return {
      disabled: true,
      pictures: [],
      deleteDialogIsOpen: false,
      selectedItem: {}
    }
  },
  methods: {
    sign() {
      if (this.pictures.length > 0) {
        // Préparez les données de l'image (supposons que vous voulez envoyer la première image)
        const imageData = this.pictures[0].file_url
        // Appelez la fonction post avec l'ID du document et les données de l'image
        DocumentService.signatures
          .post(this.document.id, imageData)
          .then(r => {
            // Reload document to update state
            DocumentService.get(this.document.id).then(v => {
              this.$emit("input", v)
              this.$emit("success", true)
            })
          })
          .catch(e => {
            if (e.response && e.response.status === 403) {
              // alert("Access denied: You do not have permission to access this resource.")
              this.$store.commit("app/message", {
                msg: this.$t("messages.error.permission_denied"),
                color: "error"
              })
            } else {
              this.$emit("error", e)
            }
          })
      } else {
        // Si aucune image, appelez simplement la fonction post avec l'ID du document
        DocumentService.signatures
          .post(this.document.id)
          .then(r => {
            // Reload document to update state
            DocumentService.get(this.document.id).then(v => {
              this.$emit("input", v)
              this.$emit("success", true)
            })
          })
          .catch(e => {
            this.$emit("error", e)
          })
      }
    },
    handleUpload() {
      this.$refs.uploadInput.click()
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    handleDelete() {
      let f = this.selectedItem.item
      let i = this.selectedItem.indice
      if (f.id && f.unassigned === true) {
        this.pictures.splice(i, 1)
      }
      if (f.id && f.unassigned === undefined) {
        f.removed = true
      } else this.pictures = this.pictures.filter(p => p !== f)

      this.$store.commit("app/message", {
        msg: this.$t("messages.information.signature"),
        color: "success"
      })

      // this.$emit("input", this.pictures)
      this.deleteDialogIsOpen = false
    },
    handleChange(e) {
      // const $ = this
      const self = this
      const files = Array.from(e.target.files)
      // alert(e.target.files)
      files.forEach((picture, i) => {
        if (imageValidator(picture)) {
          let reader = new FileReader()

          reader.addEventListener(
            "load",
            () => {
              self.pictures.push({
                file_url: reader.result,
                label: "",
                hover: false,
                removed: false
              })
              self.$nextTick(() => {
                // self.$emit("input", this.document.id)
              })
            },
            false
          )
          reader.readAsDataURL(picture)
        }
      })
    },
    handleOpenDeleteDialog(f, i) {
      this.deleteDialogIsOpen = true
      this.selectedItem = { item: f, indice: i }
    },
    publish() {
      this.document.state = STATE_ENUM.PUBLISHED
      DocumentService.patch(this.document.id, { state: STATE_ENUM.PUBLISHED })
      this.$emit("success", true, "Published")
    }
  }
}
</script>
